import { useChatTranscript } from "@circle-react/components/SettingsApp/SpacesTable/hooks/useChatTranscript";
import { ChatSpaceDropdownActions } from "@circle-react/components/Spaces/Header/SpaceHeaderActions/ChatSpaceDropdownActions";
import { useChatExportConfirmModal } from "@circle-react/components/shared/ChatExportConfirmModal";
import {
  canManageSpace,
  isChatSpace,
} from "@circle-react/helpers/spaceHelpers";
import { useIsChatSpaceExportEnabled } from "@circle-react/hooks/useIsChatSpaceExportEnabled";
import { useLargeScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import type { Space } from "@circle-react/types";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { LeaveAndDeleteSpaceOptions } from "./LeaveAndDeleteSpaceOptions";
import { ManageSpaceOptions } from "./ManageSpaceOptions";
import { NotificationsOptions } from "./NotificationsOptions";

export interface ChatSpaceOptionsProps {
  canMemberManageSpace: boolean;
  isAdmin: boolean;
  isMember: boolean;
  onInviteMember?: () => void;
  space: Space;
}

export const ChatSpaceOptions = ({
  space,
  isAdmin,
  canMemberManageSpace,
  isMember,
  onInviteMember = () => {},
}: ChatSpaceOptionsProps) => {
  const isLgScreen = useLargeScreenMediaQuery();
  const isChatSpaceExportEnabled = useIsChatSpaceExportEnabled();

  const { mutateChatTranscript } = useChatTranscript({
    space: space,
  });

  const chatExportModal = useChatExportConfirmModal();

  const handleChatExportClick = () => {
    void chatExportModal.show({
      onConfirm: (selectedOption: string) =>
        mutateChatTranscript(selectedOption),
    });
  };

  const shouldShowChatExport =
    isChatSpace(space) && isChatSpaceExportEnabled && canManageSpace(space);
  return (
    <>
      {isMember && (
        <div className="md:hidden">
          <ChatSpaceDropdownActions space={space} />
          <Dropdown.Separator />
        </div>
      )}

      {canMemberManageSpace && (
        <ManageSpaceOptions space={space} onInviteMember={onInviteMember} />
      )}

      {((isMember && isLgScreen) || canMemberManageSpace) && (
        <Dropdown.Separator />
      )}

      <NotificationsOptions space={space} />

      <LeaveAndDeleteSpaceOptions
        space={space}
        isAdmin={isAdmin}
        onInviteMember={onInviteMember}
        onChatExport={shouldShowChatExport ? handleChatExportClick : undefined}
      />
    </>
  );
};
